export default "__VITE_ASSET__COtBylZN__"